module.exports = __webpack_public_path__ + "static/media/cercaIcon.00738644.svg";